import { LayoutHOC } from 'base/ui/layout/layout';
import React from 'react'
import { createStuckWarning } from './stuckwarning';

export const createStuckWarningPage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createStuckWarning());
};
